<template>
  <div id="EnterReceipt">
    <el-table
      :summary-method="getSummaries"
      :data="tableDt"
      show-summary
      size="small"
      border
      lazy
      ref="table"
      :height="tableHeight"
      highlight-current-row
      :big-data-checkbox="bigDataCheckbox"
      @header-dragend="headerDragend"
      style="width: 100%"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height: '40px'}"
    >
      <!-- <div class="EnterReceipt_box" :style="'height:'+tableHeight+';'"> -->
      <el-table-column width="50" align="center" prop="BarCode" fixed="left">
        <template slot="header">
          <i :class="isInner" @click="clickIcon" style="color:#2594ff;font-size:18px"></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1}}</template>
      </el-table-column>
      <el-table-column align="center" fixed="left" label="操作" width="100" class="asdadfas">
        <template slot-scope="scope">
          <el-button type="text" @click.native.prevent="addRow(scope.$index)">新增</el-button>
          <el-button type="text" @click.native.prevent="deleteRow(scope.$index)">移出</el-button>
        </template>
      </el-table-column>
      <template v-for="(obj,index) in ObtainHeader">
        <el-table-column
          width="180"
          align="center"
          :index="index"
          :key="index"
          :prop="obj.Key"
          :label="obj.Rename "
          v-if="(obj.Key === 'FullName') && obj.Show == true "
          fixed="left"
        >
          <template slot-scope="scope">
            <div class="input_box ub ub-ac">
              <el-input
                size="mini"
                type="text"
                class="input_sty"
                :value="scope.row[obj.Key]"
                placeholder
                @focus="doFocus"
                @dblclick.native="dblClick(scope.$index , tableDt)"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="obj.Rename"
          :prop="obj.Key"
          align="center"
          :key="index"
          v-if="(obj.Key != 'FullName') && obj.Show == true"
        >
          <template slot-scope="scope">
            <div class="input_box ub ub-ac">
              <!-- <el-input
                size="mini"
                v-if="scope.row.FullName!==''&& scope.row.PtypeId!==''
                 &&(obj.Key=='AQty')"
                type="text"
                class="input_sty"
                :maxlength="13"
                v-model.lazy="scope.row[obj.Key]"
                @blur="changeData(scope.row,scope.$index,obj.Key)"
                @focus="inputFocus($event)"
                @input="scope.row[obj.Key]=scope.row[obj.Key].replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1');"
              ></el-input>-->
              <input
                class="input_sty"
                v-if="scope.row.FullName!==''&& scope.row.PtypeId!==''
                 &&(obj.Key=='AQty')"
                v-model.lazy="scope.row[obj.Key]"
                @blur="changeData(scope.row,scope.$index,obj.Key)"
                @focus="inputFocus($event)"
                @input="scope.row[obj.Key]=scope.row[obj.Key].replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1');"
              />

              <div v-else class="only_show_div">{{scope.row[obj.Key]}}</div>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- 商品选择弹出框 -->
    <SearchGoodsDialog
      :show.sync="seaechGoodsShow"
      v-bind="$attrs"
      @chooseGoodsBack="chooseGoodsBack"
    />
    <!-- table表格配置弹出框 -->
    <TableConfigDialog
      :pargam="pargam"
      :show.sync="tableConfigShow"
      :tableData="ObtainHeader"
      @restoreDefault="restoreDefault"
    />
    <!-- 单位、单价、选择弹出框 -->
    <SearchPriceDialog
      :show.sync="seaechbankShow"
      :searchData="searchData"
      @dbclickRow="chooseGoodsBack"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import tool from "@/utils/tool";
export default {
  name: "EnterReceipt",
  components: {},
  data() {
    return {
      tableHeight: window.innerHeight - 300 + "px",
      pargam: {
        Model: "OtherIn" //用于table配置项保存
        // style: 0 //用于客户、单位选择弹出框请求识别是客户还是供应商0客户 1供应商（销售都是客户，采购都是供应商）
      },
      tableConfigShow: false, //配置项弹出框是否显示
      seaechGoodsShow: false,
      seaechbankShow: false, //价格选择弹出框是否显示
      isInner: this.isInners,
      ObtainHeader: this.Obtain,
      tableDt: this.tableData,
      // ConfigData: this.tableConfigData, //table配置项数据
      max: this.maxs,
      searchData: { title: "", data: {}, type: "" }, //传递给选择单价与单位的弹出框,title:弹出框标题、data：传过去的数据、type：类型（单价选择、单位选择）
      /*  */
      isScroll: 17,
      showLoad: false,
      columnsBottom: [], //实际渲染表格规则
      showTableList: [], //实际显示的表格数据
      loadedNum: 0, //实际渲染的数据数量
      dataTotal: 0, //总数据条数
      dataTop: 0, //渲染数据顶部的高度
      scrollTop: 0, //滚动上下的距离
      interval: null, //判断滚动是否停止的定时器
      scrollHeight: 0, //数据滚动的高度
      selectTr: -1 //选择的行
    };
  },

  props: {
    bigDataCheckbox: { default: false, type: Boolean }, // 大量数据时候（至少数据量大于3000条每页），表格存在selection选择列表时，是否开启解决全选卡顿（缓慢）问题，开启此项可能影响table-column的selectable属性功能，最好不要使用selectable
    isInners: {
      type: String,
      default: "el-icon-s-tools"
    },
    Obtain: Array,
    tableData: Array,
    maxs: String,
    loadNum: {
      //默认加载行数
      type: [Number, String],
      default() {
        return 20;
      }
    },
    tdHeight: {
      //表格行高
      type: [Number, String],
      default() {
        return 40;
      }
    },
    // tableHeight: {
    //   //表格高度
    //   type: [Number, String],
    //   default() {
    //     return "200";
    //   }
    // },
    tableList: {
      //所有表格数据
      type: Array,
      default() {
        return [];
      }
    },
    columns: {
      //所有表格匹配规则
      type: Array,
      default() {
        return [];
      }
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 当拖动表头改变了列的宽度的时候会触发该事件(newWidth, oldWidth, column, event)
    headerDragend(newWidth, oldWidth, column, event) {
      // console.log(newWidth+':拖动的当前宽');
      // console.log(oldWidth+':上一回拖动的宽');
      // console.log(column+':拖动的哪一列');
      this.$emit("header-dragend", newWidth, oldWidth, column, event);
    },
    getMoreLog() {
      this.dom.scrollTop = this.dom.scrollTop;
    },
    restoreDefault(data) {
      this.ObtainHeader = data;
    },
    clickIcon() {
      this.tableConfigShow = true;
    },
    // 传递数据给saleorder页面
    chooseGoodsBack(data) {
      this.$emit("chooseGoodsBack", data, this.rowIndex);
    },
    dblClick(index, rows) {
      this.rowIndex = index;
      this.seaechGoodsShow = true;
    },
    doFocus(data) {},
    // 移除某一行
    deleteRow(index) {
      this.$emit("deleteRow", index);
    },
    // 新增某一行
    addRow(index) {
      this.$emit("addback", index);
    },
    // 数量、单价、金额联动
    changeData(data, index, field) {
      switch (field) {
        case "AQty":
          // 输入金额
          // 单价为0
          // 数量为0
          if (
            (Number(data.APrice) == 0 || Number(data.APrice) == "") &&
            (Number(data.AQty) != 0 || Number(data.AQty) != "")
          ) {
            data.ATotal = tool.accMul(
              Number(data.AQty),
              Number(data.APrice),
              2
            );
          }
          if (
            (Number(data.APrice) != 0 || Number(data.APrice) != "") &&
            (Number(data.AQty) != 0 || Number(data.AQty) != "")
          ) {
            data.ATotal = tool.accMul(
              Number(data.AQty),
              Number(data.APrice),
              2
            );
          }
          break;
        case "ATotal":
          if (
            (Number(data.ATotal) != 0 || Number(data.ATotal) != "") &&
            (Number(data.AQty) != 0 || Number(data.AQty) != "")
          ) {
            data.APrice = this.aseggfg(
              Number(data.ATotal),
              Number(data.AQty),
              2
            );
            // data.APrice = Number(data.ATotal) / Number(data.AQty);
          }
          if (
            (Number(data.APrice) != 0 || Number(data.APrice) != "") &&
            (Number(data.AQty) == 0 || Number(data.AQty) == "")
          ) {
            data.AQty = this.aseggfg(
              Number(data.ATotal),
              Number(data.APrice),
              2
            );
          }
          break;
        case "APrice":
          if (
            (Number(data.ATotal) != 0 || Number(data.ATotal) != "") &&
            (Number(data.AQty) == 0 || Number(data.AQty) == "")
          ) {
            data.AQty = this.aseggfg(
              Number(data.APrice),
              Number(data.ATotal),
              2
            );
          }
          if (
            (Number(data.ATotal) != 0 || Number(data.ATotal) != "") &&
            (Number(data.AQty) != 0 || Number(data.AQty) != "")
          ) {
            data.ATotal = tool.accMul(
              Number(data.AQty),
              Number(data.APrice),
              2
            );
          }
          if (
            (Number(data.ATotal) == 0 || Number(data.ATotal) == "") &&
            (Number(data.AQty) != 0 || Number(data.AQty) != "")
          ) {
            data.ATotal = tool.accMul(
              Number(data.AQty),
              Number(data.APrice),
              2
            );
          }
          break;
        default:
          break;
      }
    },
    aseggfg(arg1, arg2, fix) {
      if (!parseInt(fix) == fix) {
        return;
      }
      var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      if (m > fix) {
        return (
          Math.round(
            (Number(s1.replace(".", "")) / Number(s2.replace(".", ""))) *
              Math.pow(10, m - fix)
          ) * Math.pow(10, fix)
        );
      } else if (m <= fix) {
        return (
          (Number(s1.replace(".", "")) / Number(s2.replace(".", ""))) *
          Math.pow(10, m)
        ).toFixed(fix);
      } else {
        return arg1 / arg2; //.toFixed(fix);
      }
    },
    // 双击input弹出弹出框
    dbClickInp(data, index, key) {
      this.rowIndex = index;
      this.searchData = { title: "单价选择", data: data, type: "单价选择" };
      this.seaechbankShow = true;
    },
    // 总价计算
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总价";
          return;
        }
        const values = data.map(item => {
          if (
            column.property == "AQty" ||
            column.property == "ATotal" ||
            column.property == "Qty"
          ) {
            if (Number(item[column.property]) != "undefined") {
              return Number(item[column.property]);
            }
          }
        });
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr).toFixed(2);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });

      return sums;
    },
    // 累加数组中的number
    sum(arr) {
      var s = 0;
      for (var i = arr.length - 1; i >= 0; i--) {
        s += arr[i];
      }
      return Number(s).toFixed(2);
    },
    // 聚焦选中input全部
    inputFocus() {
      event.currentTarget.select();
    }
  },
  mounted() {
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper;
    this.dom.addEventListener("scroll", () => {
      // 滚动距离
      let scrollTop = this.dom.scrollTop;
      // 变量windowHeight是可视区的高度
      let windowHeight = this.dom.clientHeight || this.dom.clientHeight;
      // 变量scrollHeight是滚动条的总高度
      let scrollHeight = this.dom.scrollHeight || this.dom.scrollHeight;

      if (scrollTop + windowHeight === scrollHeight) {
        // 获取到的不是全部数据 当滚动到底部 继续获取新的数据
        if (!this.allData) this.getMoreLog();
        let datatable = this.$attrs.datatable;
        // let datatable = tool.getLocal("get_datatable");

        let asd = [];
        if (datatable.length > 20) {
          this.tableDt.push(
            ...this.$attrs.datatable.slice(
              [this.tableDt.length],
              [this.tableDt.length + 20]
            )
          );
        }
        // console.log("滚动距离：" + scrollTop);
        // console.log("可视高度：" + windowHeight);
        // console.log("滚动条的总高度：" + scrollHeight);
      }
    });
  },
  created() {},
  watch: {
    Obtain: {
      handler(newValue, oldValue) {
        this.ObtainHeader = newValue;
        this.tableDt = this.tableData;
      },
      deep: true
    },
    tableData: {
      handler(newValue, oldValue) {
        this.tableDt = this.tableData;
      },
      deep: true
    },
    tableDt:{
      handler(newValue, oldValue) {
        this.$emit("tableDtdata", this.$attrs.datatable);
      },
    }
  }
};
</script>

<style lang="less">
@import "./Check.less";
</style>


// WEBPACK FOOTER //
// src/components/Table/Check/Check.vue